import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const rubberDuckRoundListColumns = [
  'rubberDuckRound._id',
  'rubberDuckRound.roundId',
  'rubberDuckRound.playerId',
  'rubberDuckRound.difficulty',
  'rubberDuckRound.betAmount',
  'rubberDuckRound.reachedLane',
  'rubberDuckRound.currentMultiplier',
  'rubberDuckRound.totalWinAmount',
  'rubberDuckRound.status',
  'rubberDuckRound.createdAt',
] as const;

export type RubberDuckRoundListColumns = (typeof rubberDuckRoundListColumns)[number];

export type RubberDuckRoundListFilter = {
  'rubberDuckRound._id': string | undefined;
  'rubberDuckRound.roundId': string | undefined;
  'rubberDuckRound.playerId': string | undefined;
  'rubberDuckRound.difficulty': string | undefined;
  'rubberDuckRound.betAmount': number | undefined;
  'rubberDuckRound.reachedLane': number | undefined;
  'rubberDuckRound.currentMultiplier': number | undefined;
  'rubberDuckRound.totalWinAmount': number | undefined;
  'rubberDuckRound.status': string | undefined;
  'rubberDuckRound.createdAt': string | undefined;
};

export const defaultRubberDuckRoundListFilter: RubberDuckRoundListFilter = {
  'rubberDuckRound._id': undefined,
  'rubberDuckRound.roundId': undefined,
  'rubberDuckRound.playerId': undefined,
  'rubberDuckRound.difficulty': undefined,
  'rubberDuckRound.betAmount': undefined,
  'rubberDuckRound.reachedLane': undefined,
  'rubberDuckRound.currentMultiplier': undefined,
  'rubberDuckRound.totalWinAmount': undefined,
  'rubberDuckRound.status': undefined,
  'rubberDuckRound.createdAt': undefined,
};

export const rubberDuckRoundListColumnVisibilitySettings = {
  'rubberDuckRound._id': ColumnVisibilityType.Visible,
  'rubberDuckRound.roundId': ColumnVisibilityType.Visible,
  'rubberDuckRound.playerId': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.difficulty': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.betAmount': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.reachedLane': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.currentMultiplier': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.totalWinAmount': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.status': ColumnVisibilityType.CanBeHidden,
  'rubberDuckRound.createdAt': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<RubberDuckRoundListColumns>;

export const defaultRubberDuckRoundListColumnVisibility = defaultColumnVisibilityParams(
  rubberDuckRoundListColumnVisibilitySettings
);

export const rubberDuckRoundListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  rubberDuckRoundListColumns,
  rubberDuckRoundListColumnVisibilitySettings
);
